import validate from "/opt/render/project/src/node_modules/.pnpm/nuxt@3.13.1_@types+node@22.13.10_eslint@8.57.0_rollup@4.36.0_sass@1.77.8_typescript@5.4.5_vue-tsc@2.0.12/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45guard_45global from "/opt/render/project/src/.app/middleware/route-guard.global.ts";
import manifest_45route_45rule from "/opt/render/project/src/node_modules/.pnpm/nuxt@3.13.1_@types+node@22.13.10_eslint@8.57.0_rollup@4.36.0_sass@1.77.8_typescript@5.4.5_vue-tsc@2.0.12/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  route_45guard_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}